import React from 'react';
import { Link } from 'react-router-dom';
import { push } from 'react-router-redux';

/** Mobx state store */
import { observer } from 'mobx-react';
import BookingStoreContext from '../../stores/bookingStore';

import { AppBar, IconButton, Typography, Toolbar, Button, Hidden, Drawer, Divider, List, ListItem, 
         ListItemIcon, ListItemText } from '@material-ui/core';

import EventIcon from '@material-ui/icons/Event';
import AddBoxIcon from '@material-ui/icons/AddBox';
import ViewListIcon from '@material-ui/icons/ViewList';
import MenuIcon from '@material-ui/icons/Menu';
import DnsIcon from '@material-ui/icons/Dns';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import CustomDropdown from '../CustomDropdown/CustomDropdown';
import clientLogo from '../../assets/LogoRideWhite.png';

// Styles
import Styles from './style';
import { clearAuth } from '../login/helper';

const Header = observer(props => {
  const classes = Styles();
  const loggedUser = JSON.parse(localStorage.currentUser);
  const bookingStore = React.useContext(BookingStoreContext);
  const { pathname } = props.props.location;

  const [open, toggleMenu] = React.useState(false);

  const handleLogout = () => {
    clearAuth();
    props.props.history.push('/login');
    push('/login');
  };

  const handleAllBookings = () => {
    bookingStore.setValue('isLoading', true);
    handleDrawerClose();
    props.props.history.push('/requests/all');
    push('/requests/all');
  };

  const handleRequestedBookings = () => {
    bookingStore.setValue('isLoading', true);
    handleDrawerClose();
    props.props.history.push('/requests');
    push('/requests');
  };

  const handleDrawerClose = () => {
    toggleMenu(false);
  };

  const handleDrawerOpen = () => {
    toggleMenu(true);
  };

  const lockedMenuOption = (menuOption) => {
    const usersOption = {
      'collaborator': ['Solicitudes Pendientes', 'Solicitudes Atendidas', 'Configuración'],
      'driver': ['Solicitudes Pendientes', 'Solicitudes Atendidas', 'Crear Solicitud', 'Configuración']
    };
    const options = usersOption[loggedUser.role];
    return !(!!options && !!(options.find( f => f === menuOption)));
  }

  const getButtonClassName = (path) => {
    return `${classes.headerButton}${pathname === path ? '__selected' : '' }`
  }

  return (
    <div>
      <AppBar className={classes.navbar} position="static">
        <Toolbar className={classes.toolbar}>
          <div>
            <Hidden only={['xs', 'sm']}>
              <img
                src={clientLogo}
                alt="Logo" className={classes.logo}
              />

              <div className={classes.inlineFlex}>
                <Link to={'/home'} className={classes.link}>
                  <Button size="small" className={getButtonClassName('/home')}>
                    VER CALENDARIO
                  </Button>
                </Link>
                &nbsp;&nbsp;
                {lockedMenuOption('Solicitudes Pendientes') && (
                  <>
                    <Link to="/requests" className={classes.link}>
                      <Button size="small" className={getButtonClassName('/requests')} onClick={handleRequestedBookings}>
                        SOLICITUDES PENDIENTES
                      </Button>
                    </Link>
                    &nbsp;&nbsp;
                  </>
                )}
                <Button size="small" className={getButtonClassName('/requests/all')} onClick={handleAllBookings}>
                  {lockedMenuOption('Solicitudes Atendidas') ? 'SOLICITUDES' : 'VER SOLICITUDES'}
                </Button>
                &nbsp;&nbsp;
                { lockedMenuOption('Crear Solicitud') && 
                  (<Link to="/requests/new" className={classes.link}>
                  <Button size="small" className={getButtonClassName('/requests/new')}>
                    CREAR SOLICITUD
                  </Button>
                </Link>
                )}
              </div>
            </Hidden>

            <Hidden only={['md', 'lg', 'xl']}>
              <IconButton
                color="secondary"
                aria-label="open drawer"
                edge="end"
                onClick={handleDrawerOpen}
                // className={clsx(open && classes.hide)}
              >
                <MenuIcon />
              </IconButton>
            </Hidden>
          </div>
          <div style={{ marginLeft: 'auto' }}>
            <Typography className={classes.linkHeader}>
              {`${loggedUser.first_name} ${loggedUser.last_name}`}
            </Typography>
            <CustomDropdown
              hoverColor="primary"
              buttonText={loggedUser.role}
              // dropdownHeader="Dropdown Header"
              buttonProps={{
                className: classes.linkHeader,
                color: 'transparent',
              }}
              dropdownList={[
                lockedMenuOption('Configuración') && (
                  <Link to="/config" className={classes.link}>
                    <Typography style={{ color: 'gray' }}>Configuración</Typography>
                  </Link>
                ),
                <Link to="/login" className={classes.link}>
                  <Typography style={{ color: 'gray' }} onClick={handleLogout}>
                    Cerrar sesión
                  </Typography>
                </Link>,
              ]}
            />
          </div>
        </Toolbar>
      </AppBar>
      <Drawer
        className={classes.drawer}
        variant="persistent"
        anchor="left"
        open={open}
        classes={{
          paper: classes.drawer,
        }}
      >
        <div className={classes.drawerHeader} style={{ marginLeft: 'auto' }}>
          <IconButton onClick={handleDrawerClose} color="secondary">
            <ChevronLeftIcon />
          </IconButton>
        </div>
        <Divider />
        <List>
          <Link to={'/home'} className={classes.link} onClick={handleDrawerClose}>
            <ListItem button>
              <ListItemIcon >
                <EventIcon color="secondary"/>
              </ListItemIcon>
              <ListItemText primary="Calendario" />
            </ListItem>
          </Link>
          {lockedMenuOption('Solicitudes Pendientes') && (
            <Link to="/requests" className={classes.link} onClick={handleRequestedBookings}>
              <ListItem button>
                <ListItemIcon>
                  <DnsIcon color="secondary"/>
                </ListItemIcon>
                <ListItemText primary="Solicitudes Pendientes" />
              </ListItem>
            </Link>
          )}

          <Link to="/requests/all" className={classes.link} onClick={handleAllBookings}>
            <ListItem button>
              <ListItemIcon>
                <ViewListIcon color="secondary"/>
              </ListItemIcon>
              <ListItemText primary={lockedMenuOption('Solicitudes Atendidas') ? 'Solicitudes Atendidas' : 'Ver Solicitudes'} />
            </ListItem>
          </Link>
          {lockedMenuOption('Crear Solicitud') && 
            (<Link to="/requests/new" className={classes.link} onClick={handleDrawerClose}>
              <ListItem button>
                <ListItemIcon>
                  <AddBoxIcon color="secondary"/>
                </ListItemIcon>
                <ListItemText primary="Crear Solicitud" />
              </ListItem>
            </Link>)
          }
        </List>
        <Divider />
      </Drawer>
    </div>
  );
});

export default Header;
